import React, { useRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './Sidebar.module.scss';
import { Icon } from '../../Icon';
import { useUIContext } from '../../../context/UIContext';
import useOutsideClick from '../../../hooks/useOutsideClick';

export default function Sidebar(props) {
  const {
    className,
    linksClassName,
    footerClassName,
    height,
    isMobile,
    profile,
    links,
    footer,
    logo,
    inModal = false,
    fadeIn = false,
    ...rest
  } = props;

  const { toggleMobileSidebar } = useUIContext();
  const sidebarRef = useRef(null);

  useOutsideClick(sidebarRef, () => {
    isMobile && toggleMobileSidebar(false)
  });

  return (
    <div className={cx(styles.sidebar, className, { [styles.mini]: !isMobile })} {...rest} ref={sidebarRef}>
      <div className={styles.innerWrapper} style={{ height: isMobile ? `${height}px` : '100%' }}>
        <div className={cx(styles.content, { [styles.mini]: !isMobile })}>
          {(isMobile || logo) && <div className={cx(styles.headerContainer, { [styles.alignEnd]: isMobile && !logo })}>
            {logo && <div className={cx(styles.logo, { [styles.mini]: !isMobile })}>{logo}</div>}
            {isMobile && <div className={styles.closeButton} onClick={toggleMobileSidebar} onDoubleClick={() => console.log('double click')}>
                <Icon src="close" className={styles.closeIcon} />
            </div>}
          </div>}
          {profile && <div className={cx(styles.profile)}>{profile}</div>}
          {links && <div className={cx(styles.links, { [styles.mini]: !isMobile }, linksClassName)}>{links}</div>}
        </div>
        <div className={cx(styles.footer, footerClassName)}>{footer}</div>
        {fadeIn && <div className={styles.fadeIn} />}
      </div>
    </div>
  );
}

Sidebar.defaultProps = {};

Sidebar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};
